export default __webpack_public_path__ + "locales/bg/MainBar.json?hash=e5afc02e01d49b3422d437c46f23f420";